'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Avatar = require('boring-avatars');
var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
var avatar = require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
var tooltip = require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../tooltip/hover-tooltip/hover-tooltip.js');
require('../../icon/font-icon/font-icon.js');
require('react-laag');
require('react-transition-group');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var standardTooltip = require('../../tooltip/standard-tooltip/standard-tooltip.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var Avatar__default = /*#__PURE__*/_interopDefaultCompat(Avatar);
var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const baseName = 'avatar';
const BaseAvatar = (props)=>{
    const { avatarProps , email , image , imageProps , name , selected =true , showImage , size =40 , tooltipProps , triggerOffset =5 , type =avatar.AvatarTypes.Beam , variantName , ...linkProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(standardTooltip.StandardTooltip, _extends({}, tooltipProps, {
        id: email,
        tooltip: name,
        triggerOffset: triggerOffset,
        type: tooltip.TooltipTypes.Label
    }), /*#__PURE__*/ React__default.default.createElement("a", _extends({}, linkProps, {
        className: classnames__default.default(`bf-${baseName}__${variantName}`, linkProps && linkProps.className),
        href: `mailto:${email}`,
        rel: "noopener noreferrer",
        style: {
            height: size,
            width: size
        },
        target: "_blank"
    }), showImage && image ? /*#__PURE__*/ React__default.default.createElement("img", _extends({}, imageProps, {
        alt: name,
        "data-testid": email,
        src: image,
        style: {
            ...imageProps?.style,
            height: size,
            width: size
        }
    })) : /*#__PURE__*/ React__default.default.createElement(Avatar__default.default, _extends({}, avatarProps, {
        colors: selected ? [
            colors.BrandfolderHexColors.AquaKnockoff,
            colors.BrandfolderHexColors.BlueberryDelight,
            colors.BrandfolderHexColors.PurplePopsicle
        ] : [
            colors.BrandfolderHexColors.DirtyMarshmallow,
            colors.BrandfolderHexColors.GrayDark,
            colors.BrandfolderHexColors.GrayMedium
        ],
        name: name,
        size: size,
        variant: type
    }))));
};

exports.BaseAvatar = BaseAvatar;
//# sourceMappingURL=base-avatar.js.map
